import { Selector } from '@ngxs/store';
import { MessagingState, MessagingStateModel } from './messaging.state';
import { ChatListItem, ChatWithUsers, MessageViewDto } from '@smatchy/sdk';

function deduplicateMessages(messages: MessageViewDto[]): MessageViewDto[] {
  if (!messages) return [];
  const map = new Map<string, MessageViewDto>();
  for (const msg of messages) {
    if (msg && msg._id) {
      map.set(msg._id, msg);
    }
  }
  return Array.from(map.values());
}

export class MessagingSelector {
  @Selector([MessagingState])
  static isLoading(state: MessagingStateModel): boolean {
    return state.isLoading;
  }

  @Selector([MessagingState])
  static chats(state: MessagingStateModel): ChatListItem[] {
    return state.chats ?? [];
  }

  @Selector([MessagingState])
  static archivedChats(state: MessagingStateModel): ChatListItem[] {
    return state.archivedChats ?? [];
  }

  @Selector([MessagingState])
  static unreadMessagesCount(state: MessagingStateModel): number {
    return (state.chats ?? []).reduce((count, chat) => count + (chat.new_messages ?? 0), 0);
  }

  @Selector([MessagingState])
  /** Nothing until a conversation is opened, which is what the state holds. */
  static currentChat(state: MessagingStateModel): ChatWithUsers | undefined {
    return state.currentChat;
  }

  @Selector([MessagingState])
  static messages(state: MessagingStateModel): MessageViewDto[] {
    return deduplicateMessages(state.messages);
  }

  @Selector([MessagingState])
  static messagesSortByLast(state: MessagingStateModel): MessageViewDto[] {
    return deduplicateMessages(state.messages).sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
  }

  @Selector([MessagingState])
  static canLoadMore(state: MessagingStateModel): boolean {
    return state.canLoadMore;
  }

  @Selector([MessagingState])
  static currentChatError(state: MessagingStateModel): string | null {
    return state.currentChatError;
  }
}
